import { OrganizationKeyName } from "../../../model/Organization";
import { Order } from "../model/OrderSuccessResponse";

export const REFUND_ORDER = "SHOP:REFUND_ORDER";

export const refundOrderAction = (
  organization: OrganizationKeyName,
  id: string,
  order: Order,
  amount: number
) => ({
  type: REFUND_ORDER as typeof REFUND_ORDER,
  organization,
  id,
  order,
  amount,
});

export type RefundOrderAction = ReturnType<typeof refundOrderAction>;
